import '@/app/app.css';
import './index.css';

import '@/app/app';

window.addEventListener('DOMContentLoaded', () => {
	console.log('index');
});
